/**
 * Partner Filter Interfaces
 *
 * These are minimal shared filter types used across the application for partner-related entities.
 * They represent the contract between the core layer (services, helpers) and feature modules.
 *
 * NOTE: These are NOT NgRx state types. Feature state management remains internal to feature modules.
 */

// ============================================================================
// Filter Enums
// ============================================================================

export enum PartnerIntegrationTypeFilter {
  All = 'All',
  Integration = 'Integration',
  Manual = 'Manual',
}

export enum PartnerStatusFilter {
  All = 'All',
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum PartnerAvailabilityFilter {
  All = 'All',
  Available = 'Available',
  Unavailable = 'Unavailable',
}

export enum PartnerImportStatusFilter {
  All = 'All',
  Synced = 'Synced',
  Orphaned = 'Orphaned',
  HasConflicts = 'HasConflicts',
}

// ============================================================================
// Filter Interfaces
// ============================================================================

/**
 * Base filter interface for partner-related entities
 */
export interface BasePartnerFilter {
  search: string;
  type: PartnerIntegrationTypeFilter;
  status: PartnerStatusFilter;
  availability: PartnerAvailabilityFilter;
  importStatus: PartnerImportStatusFilter;
}

/**
 * Filter for partners list
 */
export interface PartnersFilter extends BasePartnerFilter {}

/**
 * Filter for locations list
 */
export interface LocationsFilter extends BasePartnerFilter {}

/**
 * Filter for doctors list
 */
export interface DoctorsFilter extends BasePartnerFilter {}

/**
 * Filter for offerings list
 */
export interface OfferingsFilter extends BasePartnerFilter {
  mappedOnly: boolean | null;
}
